import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { deepDiver } from 'helpers/utilities';

import EventTimeline from 'components/shared/EventTimeline';
import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';

const StyledTransactionCard = styled(Card)`
  color: #424242 !important;
  font-family: 'Circular', sans-serif !important;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
`;

const TicketHistory = ({ maintenanceTicket }) => (
  <div className="row">
    <h3 style={{ margin: '0 0 15px' }}>
      {getTranslatedString('landlordPortal.ticketDetailsOverview.history')}
    </h3>
    <StyledTransactionCard>
      <CardText style={{ padding: '0 10px' }}>
        <EventTimeline events={deepDiver(maintenanceTicket, 'events')} />
      </CardText>
    </StyledTransactionCard>
  </div>
);

export default TicketHistory;
